/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Roles, RolesInterface } from "../Roles";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ArraysDifferentLength",
    type: "error",
  },
  {
    inputs: [],
    name: "ModuleTransactionFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "NoMembership",
    type: "error",
  },
  {
    inputs: [],
    name: "SetUpModulesAlreadyCalled",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16[]",
        name: "roles",
        type: "uint16[]",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "AssignRoles",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousAvatar",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newAvatar",
        type: "address",
      },
    ],
    name: "AvatarSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "guard",
        type: "address",
      },
    ],
    name: "ChangedGuard",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "DisabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "EnabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "initiator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "avatar",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "RolesModSetup",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "defaultRole",
        type: "uint16",
      },
    ],
    name: "SetDefaultRole",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "multisendAddress",
        type: "address",
      },
    ],
    name: "SetMultisendAddress",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousTarget",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newTarget",
        type: "address",
      },
    ],
    name: "TargetSet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "allowTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "_roles",
        type: "uint16[]",
      },
      {
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "assignRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "avatar",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "defaultRoles",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "prevModule",
        type: "address",
      },
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "disableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "enableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModule",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModuleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRole",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRoleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "returnData",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getGuard",
    outputs: [
      {
        internalType: "address",
        name: "_guard",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "start",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pageSize",
        type: "uint256",
      },
    ],
    name: "getModulesPaginated",
    outputs: [
      {
        internalType: "address[]",
        name: "array",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "next",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "guard",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_module",
        type: "address",
      },
    ],
    name: "isModuleEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "multisend",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "revokeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeAllowFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "bool[]",
        name: "isParamScoped",
        type: "bool[]",
      },
      {
        internalType: "enum ParameterType[]",
        name: "paramType",
        type: "uint8[]",
      },
      {
        internalType: "enum Comparison[]",
        name: "paramComp",
        type: "uint8[]",
      },
      {
        internalType: "bytes[]",
        name: "compValue",
        type: "bytes[]",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeFunctionExecutionOptions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "paramIndex",
        type: "uint256",
      },
      {
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        internalType: "enum Comparison",
        name: "paramComp",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "compValue",
        type: "bytes",
      },
    ],
    name: "scopeParameter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "paramIndex",
        type: "uint256",
      },
      {
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        internalType: "bytes[]",
        name: "compValues",
        type: "bytes[]",
      },
    ],
    name: "scopeParameterAsOneOf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
    ],
    name: "scopeRevokeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "scopeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
    ],
    name: "setAvatar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
    ],
    name: "setDefaultRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_guard",
        type: "address",
      },
    ],
    name: "setGuard",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_multisend",
        type: "address",
      },
    ],
    name: "setMultisend",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    name: "setTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "initParams",
        type: "bytes",
      },
    ],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "target",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint8",
        name: "paramIndex",
        type: "uint8",
      },
    ],
    name: "unscopeParameter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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$26c8ee7675adcd4387514ebc7646e15ffa$__63a2f6f6d0606b60008661ffff1661ffff1681526020019081526020016000208585856040518563ffffffff1660e01b815260040161086194939291906155a1565b60006040518083038186803b15801561087957600080fd5b505af415801561088d573d6000803e3d6000fd5b50505050505050565b61089e613008565b73ffffffffffffffffffffffffffffffffffffffff166108bc612057565b73ffffffffffffffffffffffffffffffffffffffff1614610912576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610909906151c7565b60405180910390fd5b80606a60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548161ffff021916908361ffff1602179055507f197e61bb67ba4b0f657afcb5d2dbed385d50b697c51090f466cdbcc4c30a21ce828260405161099d929190614f7a565b60405180910390a15050565b6109b1613008565b73ffffffffffffffffffffffffffffffffffffffff166109cf612057565b73ffffffffffffffffffffffffffffffffffffffff1614610a25576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610a1c906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63163592dd606b60008761ffff1661ffff168152602001908152602001600020868686866040518663ffffffff1660e01b8152600401610a7e9594939291906153fc565b60006040518083038186803b158015610a9657600080fd5b505af4158015610aaa573d6000803e3d6000fd5b5050505050505050565b610abc613008565b73ffffffffffffffffffffffffffffffffffffffff16610ada612057565b73ffffffffffffffffffffffffffffffffffffffff1614610b30576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610b27906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__6377cff804606b60008661ffff1661ffff1681526020019081526020016000208585856040518563ffffffff1660e01b8152600401610b879493929190615308565b60006040518083038186803b158015610b9f57600080fd5b505af4158015610bb3573d6000803e3d6000fd5b50505050505050565b606960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b606a6020528060005260406000206000915054906101000a900461ffff1681565b60008173ffffffffffffffffffffffffffffffffffffffff16600173ffffffffffffffffffffffffffffffffffffffff1614158015610cce5750600073ffffffffffffffffffffffffffffffffffffffff16606860008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614155b9050919050565b610cdd613008565b73ffffffffffffffffffffffffffffffffffffffff16610cfb612057565b73ffffffffffffffffffffffffffffffffffffffff1614610d51576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d48906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__633c5a24e2606b60008761ffff1661ffff168152602001908152602001600020868686866040518663ffffffff1660e01b8152600401610daa95949392919061554e565b60006040518083038186803b158015610dc257600080fd5b505af4158015610dd6573d6000803e3d6000fd5b5050505050505050565b610de8613008565b73ffffffffffffffffffffffffffffffffffffffff16610e06612057565b73ffffffffffffffffffffffffffffffffffffffff1614610e5c576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610e53906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__635ebbaa68606b60008761ffff1661ffff168152602001908152602001600020868686866040518663ffffffff1660e01b8152600401610eb59594939291906153fc565b60006040518083038186803b158015610ecd57600080fd5b505af4158015610ee1573d6000803e3d6000fd5b5050505050505050565b610ef3613008565b73ffffffffffffffffffffffffffffffffffffffff16610f11612057565b73ffffffffffffffffffffffffffffffffffffffff1614610f67576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f5e906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__632af6aecb606b60008e61ffff1661ffff1681526020019081526020016000208d8d8d8d8d8d8d8d8d8d8d6040518d63ffffffff1660e01b8152600401610fce9c9b9a9998979695949392919061534d565b60006040518083038186803b158015610fe657600080fd5b505af4158015610ffa573d6000803e3d6000fd5b505050505050505050505050505050565b611013613008565b73ffffffffffffffffffffffffffffffffffffffff16611031612057565b73ffffffffffffffffffffffffffffffffffffffff1614611087576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161107e906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63edf909e3606b60008b61ffff1661ffff1681526020019081526020016000208a8a8a8a8a8a8a8a6040518a63ffffffff1660e01b81526004016110e8999897969594939291906154c7565b60006040518083038186803b15801561110057600080fd5b505af4158015611114573d6000803e3d6000fd5b505050505050505050505050565b60008073ffffffffffffffffffffffffffffffffffffffff16606860003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614156111f2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016111e9906151e7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63db50e575606b6000606a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900461ffff1661ffff1661ffff168152602001908152602001600020606960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1689898989896040518863ffffffff1660e01b81526004016112be9796959493929190615267565b60006040518083038186803b1580156112d657600080fd5b505af41580156112ea573d6000803e3d6000fd5b5050505061133e868686868080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f8201169050808301925050505050505085613010565b905095945050505050565b611351613008565b73ffffffffffffffffffffffffffffffffffffffff1661136f612057565b73ffffffffffffffffffffffffffffffffffffffff16146113c5576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016113bc906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63cfe4317a606b60008561ffff1661ffff16815260200190815260200160002084846040518463ffffffff1660e01b815260040161141a939291906152d1565b60006040518083038186803b15801561143257600080fd5b505af4158015611446573d6000803e3d6000fd5b505050505050565b60006060600073ffffffffffffffffffffffffffffffffffffffff16606860003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff161415611521576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611518906151e7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63db50e575606b6000606a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900461ffff1661ffff1661ffff168152602001908152602001600020606960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff168a8a8a8a8a6040518863ffffffff1660e01b81526004016115ed9796959493929190615267565b60006040518083038186803b15801561160557600080fd5b505af4158015611619573d6000803e3d6000fd5b5050505061166d878787878080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f8201169050808301925050505050505086613305565b915091509550959350505050565b606660009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6116a9613008565b73ffffffffffffffffffffffffffffffffffffffff166116c7612057565b73ffffffffffffffffffffffffffffffffffffffff161461171d576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611714906151c7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__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__$26c8ee7675adcd4387514ebc7646e15ffa$__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__$26c8ee7675adcd4387514ebc7646e15ffa$__63512ce0f2606b60008a61ffff1661ffff168152602001908152602001600020898989898989896040518963ffffffff1660e01b815260040161215c98979695949392919061544f565b60006040518083038186803b15801561217457600080fd5b505af4158015612188573d6000803e3d6000fd5b5050505050505050505050565b6000806000838060200190518101906121ae9190613f8b565b9250925092506121bc6136cf565b81606660006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555080606760006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555061224783612f10565b61224f6137b8565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff167f34d3b96a088381c6843a1f9d94d251afa88f83cc7a0d17fc23a7057506a3fc6d846040516122c39190614f16565b60405180910390a450505050565b6122d9613008565b73ffffffffffffffffffffffffffffffffffffffff166122f7612057565b73ffffffffffffffffffffffffffffffffffffffff161461234d576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612344906151c7565b60405180910390fd5b81819050848490501461238c576040517f74f4d53700000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60005b848490508161ffff16101561247a5782828261ffff168181106123b5576123b4615b73565b5b90506020020160208101906123ca919061426a565b606b600087878561ffff168181106123e5576123e4615b73565b5b90506020020160208101906123fa9190614369565b61ffff1661ffff16815260200190815260200160002060000160008873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff021916908315150217905550808061247290615aa1565b91505061238f565b5061248485610c03565b61249257612491856117a6565b5b7f4dcd99505817a4d3e4d3f751a4a49739ec38cb0f83319ff1224a3b289597e86c85858585856040516124c9959493929190614f31565b60405180910390a15050505050565b60006060600073ffffffffffffffffffffffffffffffffffffffff16606860003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614156125ab576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016125a2906151e7565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$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";

type RolesConstructorParams =
  | [linkLibraryAddresses: RolesLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RolesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Roles__factory extends ContractFactory {
  constructor(...args: RolesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, Roles__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = "Roles";
  }

  static linkBytecode(linkLibraryAddresses: RolesLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$26c8ee7675adcd4387514ebc7646e15ffa\\$__", "g"),
      linkLibraryAddresses["contracts/Permissions.sol:Permissions"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    _owner: string,
    _avatar: string,
    _target: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Roles> {
    return super.deploy(
      _owner,
      _avatar,
      _target,
      overrides || {}
    ) as Promise<Roles>;
  }
  getDeployTransaction(
    _owner: string,
    _avatar: string,
    _target: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _owner,
      _avatar,
      _target,
      overrides || {}
    );
  }
  attach(address: string): Roles {
    return super.attach(address) as Roles;
  }
  connect(signer: Signer): Roles__factory {
    return super.connect(signer) as Roles__factory;
  }
  static readonly contractName: "Roles";
  public readonly contractName: "Roles";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RolesInterface {
    return new utils.Interface(_abi) as RolesInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Roles {
    return new Contract(address, _abi, signerOrProvider) as Roles;
  }
}

export interface RolesLibraryAddresses {
  ["contracts/Permissions.sol:Permissions"]: string;
}
